import { AutoComplete, Breadcrumb, PopUpModal, SuccessPopupModal, TextInput, Title } from '../../Components/Atoms';
import { saveVehicleDetails, getAllModels, getBatteriesData, updateVehicleDetail, deleteVehicleFromInventory } from '../../APIs';
import { Button, useToast } from '@chakra-ui/react';
import { useEffect, useMemo, useState, Fragment } from 'react';
import PATH from '../../Routes/paths';
import './style.css';
import { CHARGING_TYP } from '../../Library/constants';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

const FIELD_TYPE = {
  TEXT: 1,
  AUTOCOMPLETE: 2,
};

const initialState = {
  reg: "",
  chNum: "",
  clrId: "",
  clrNm: "",
  mo: "",
  md: "",
  bmid: "",
  mtrNum: "",
  cTyp: "",
  imei: "",
  bId: ""
};

const AddVehicle = () => {
  const [formData, setFormData] = useState(initialState);
  const [vehModelsOption, setVehModelsOption] = useState([]);
  const [batteriesOption, setBatteriesOption] = useState([]);
  const [vehColorOption, setVehColorOption] = useState([]);
  const [formErrors, setFormErrors] = useState({});
  const [successModal, setSuccessModal] = useState({isOpen: false, msg: ""});
  const [confirmDeleteVehicle, setConfirmDeleteVehicle] = useState({});
  const [searchParams] = useSearchParams();
  const Navigate = useNavigate();
  const location = useLocation();
  const Toast = useToast();

  const vId   = searchParams.get('vid');
  const isEdit = location.state && location.state.vehicleDetail;
  const title = isEdit ? "Update Vehicle " : "Vehicle Details";

  useEffect(() => {
    getBatteriesData()
      .then(data => {
        const options = data.map(bat => {
          return { label: bat.bId, value: bat.bId }
        })
        setBatteriesOption(prev => [...prev, ...options])
      })
      .catch(error => console.error(error))

    getAllModels()
      .then(data => {
        const options = data.map(mo => {
          return { label: mo.nm, value: mo.idx, colors: mo.colors, bmid: mo.bmid }
        })
        setVehModelsOption(options);
      })
      .catch(error => console.error(error))
  }, []);

  useEffect(() => {

    if (location.state && location.state.vehicleDetail ){
      const newObj = {}
      Object.keys(initialState).forEach(field => newObj[field] = location.state.vehicleDetail[field])
      
      const model = vehModelsOption.filter(mo => mo.value === (Number(newObj.md) ? +newObj.md : newObj.md))[0];
      if (model){
        const { colors } = model;
        if (colors && colors.length) {
          const ColorOptions = colors.map(color => ({ label: color.nm, value: color.idx }))
          setVehColorOption(ColorOptions);
        }
      }
      const batteryExist = batteriesOption.find(bd => bd.value === newObj.bId)
      if (!batteryExist)
        setBatteriesOption(prev => [{ label: location.state.vehicleDetail.bId, value: location.state.vehicleDetail.bId }, ...prev])

      setFormData(newObj);
    }

  }, [batteriesOption, location, vehModelsOption]);

  const addVehicleFormFields = useMemo(() => [
    {
      type: FIELD_TYPE.TEXT,
      label: "Registration Number",
      name: "reg",
      placeholder: "Enter Registration Number ",
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Chassis Number",
      name: "chNum",
      placeholder: "Enter Chassis Number ",
      required: true
    },
    {
      type: FIELD_TYPE.AUTOCOMPLETE,
      label: "Vehicle Model",
      name: "md",
      placeholder: "Select Vehicle Model",
      options: vehModelsOption,
      required: true,
      onChange: (value, Option) => {
        const {colors, label, bmid} = Option;

        setFormFieldData("md")(value);
        setFormFieldData("mo")(label);
        setFormFieldData("bmid")(bmid);
        setFormFieldData("clrId")("");

        if (colors && colors.length) {
          const ColorOptions = colors.map(color => ({ label: color.nm, value: color.idx }))
          setVehColorOption(ColorOptions);
        }
      }
    },
    {
      type: FIELD_TYPE.AUTOCOMPLETE,
      label: "Vehicle Color",
      name: "clrId",
      placeholder: "Select Vehicle Colour",
      options: vehColorOption,
      required: true,
      onChange: (value, Option) => {        
        setFormFieldData("clrId")(value);
        setFormFieldData("clrNm")(Option.label);
      }
    },
    {
      type: FIELD_TYPE.AUTOCOMPLETE,
      label: "Charger Type",
      name: "cTyp",
      placeholder: "Select Charger Type",
      options: Object.entries(CHARGING_TYP).map(([key, value]) => ({ label: key, value: value })),
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Motor Number",
      name: "mtrNum",
      placeholder: "Enter Motor Number",
      required: true
    },
    {
      type: FIELD_TYPE.AUTOCOMPLETE,
      label: "Battery Number",
      name: "bId",
      placeholder: "Select Battery Number",
      options: batteriesOption,
      note: "Note : Add batteries to inventory before vehicle assignment",
      required: true
    },
    {
      type: FIELD_TYPE.TEXT,
      label: "Ajjas IMEI",
      name: "imei",
      placeholder: "Enter Ajjas IMEI",
      regex: /^\d{15}$/,
      required: true,
      disabled: isEdit ? true : false
    }
  ], [vehModelsOption, vehColorOption, batteriesOption, isEdit])

  const setFormFieldData = (key) => (value) => {
    setFormData(prev => ({ ...prev, [key]: value }));
  };

  const saveVehicleData = (vehicleData) => {
    let postFunction = saveVehicleDetails;

    if (location.state && location.state.vehicleDetail) {
      postFunction = updateVehicleDetail;
      vehicleData = { ...vehicleData, vid: vId};
    }
    else vehicleData = { vehicles: [vehicleData] }

    postFunction(vehicleData, (failure, success) => {
      if (failure) {
        const errMsg = JSON.parse(failure).data;
        Toast({ isClosable: true, description: errMsg, position: "bottom", variant: "subtle", duration:"3000"})
      }
      else {
        setFormData(initialState);
        setSuccessModal(() => ({
          isOpen: true,
          msg: isEdit ? "Vehicle detail updated" : "Vehicle added successfully"
        }))
      };
    })
  };

  const submitHandler = () => {
    let errors = {}, sendData = formData;

    // Checking if any of the required fields are empty, then show error and updating the data to sendData
    for (let field of addVehicleFormFields) {
      let {name, label} = field;
      if (!field.required)
        continue;

      if (!formData[name]) {
        errors[name] = `Please enter ${label.toLowerCase()}`;
      } else if (field.regex && !field.regex.test(formData[name])) {
        errors[name] = `Please enter valid ${label.toLowerCase()}`;
      }
    }

    // If any of the required input do not have data 
    if (Object.keys(errors).length) return setFormErrors(errors);
    else setFormErrors({});

    if (isEdit) {
      let updatedData = {};
      const vehicleDetail = location.state.vehicleDetail;

      for (let field of Object.keys(sendData)) {
        if ((vehicleDetail[field] !== sendData[field]) && sendData[field])
          updatedData[field] = sendData[field];
      }

      if (updatedData['bId'] && vehicleDetail['bId'] && updatedData['bId'] !== vehicleDetail['bId']) 
        updatedData['oldBid'] = vehicleDetail['bId'];

      // During update detail, none of the input updated
      if (!Object.keys(updatedData).length) return Toast({ title: "Nothing to Update", variant: "subtle", position: "bottom", isClosable: true });

      sendData = updatedData;
    }

    saveVehicleData(sendData);
  };

  const DeleteVehicle = (vId) => {
    deleteVehicleFromInventory(+vId, (err) => {
      if (err) {
        console.error("AddVehicle : Error while removing vehicle", err);
        setConfirmDeleteVehicle({});
        Toast({ isClosable: true, description: "Failed to remove vehicle", position: "bottom", status: "error", variant: "solid" });
      }
      else {
        setSuccessModal({ isOpen: true, msg: "Vehicle removed successfully" });
      }
    })
  }

  const deleteVehicle = () => {
    setConfirmDeleteVehicle({
      open: true,
      modalMsg: "Removing vehicle will also unmap the Ajjas device. Are you sure you want to remove vehicle from inventory?",
      confirmBtn: "Remove",
      closeBtn: "Cancel",
      onConfirm: () => DeleteVehicle(vId),
      onModalClose: () => setConfirmDeleteVehicle({}),
    });
  }

  const breadcrumbPaths = [
    { idx: 1, name: "Inventory Management", link: PATH.INVENTORY },
    { idx: 2, name: "Vehicles", link: PATH.VEHICLES },
    { idx: 3, name: title, link: "", isCurrentPage: true },
  ];

  return (
    <section className="panel-main add-vehicle-main">
      <PopUpModal {...confirmDeleteVehicle} />
      <SuccessPopupModal open={successModal.isOpen} modalMsg={successModal.msg} closeBtn={"Okay"} modalSize={"lg"} onModalClose={() => { setSuccessModal(prev => ({...prev, isOpen:false})); Navigate(PATH.VEHICLES) }} />

      <div>
        <Breadcrumb paths={breadcrumbPaths} />
      </div>
      {/* <Button
        mb="8px"
        leftIcon={<AddModelIcon />}
        className="add-vehicle-bulk-upload-btn"
        onClick={() => Navigate("")}
      >
        Bulk Upload
      </Button> */}
      {
        isEdit && <Button variant={"outline"} className='vehicle-remove-btn' onClick={deleteVehicle}>Remove from Inventory </Button>
      }
      <div className='add-vehicle'>
        <div className='add-vehicle-card'>
          <Title>{title}</Title>
          <form className='add-vehicle-form'>
            {
              addVehicleFormFields.map((formField, idx) => {
                return <Fragment key={idx}>
                  {
                    formField.type === FIELD_TYPE.TEXT && (
                      <TextInput
                        inputName={formField.name || ""}
                        placeholder={formField.placeholder}
                        className="add-vehicle-text-field"
                        label={formField.label}
                        labelClassName="add-vehicle-text-field-label"
                        errMessage={formErrors[formField.name] || ""}
                        onChange={setFormFieldData(formField.name)}
                        value={formData[formField.name] || ""}
                        isRequired={formField.required}
                        disabled={formField.disabled}
                      />
                    )
                  }
                  {
                    formField.type === FIELD_TYPE.AUTOCOMPLETE && (
                      <AutoComplete
                        options={formField.options}
                        label={formField.label}
                        labelClassName={"add-vehicle-autocomplete-field-label"}
                        autoCompleteClassName={"add-vehicle-autocomplete"}
                        className={"add-vehicle-autocomplete-field"}
                        placeholder={formField.placeholder}
                        errMessage={formErrors[formField.name] || ""}
                        inputName={formField.name}
                        onChange={formField.onChange || setFormFieldData(formField.name)}
                        value={formData[formField.name] || ""}
                        note={formField.note}
                        isRequired={formField.required}
                        disabled={formField.disabled}
                      />
                    )
                  }
                </Fragment>
              })
            }
          </form>
        </div>
        <div className="add-vehicle-submit-button">
          <Button type="submit" className="add-vehicle-button" onClick={submitHandler}>
            {isEdit ? "Save" : 'Add Vehicle'} 
          </Button>
        </div>
      </div>
    </section>
  )
};

export default AddVehicle;